var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { _get, _post } from '../request';
/**
 * 查询是否是指定租户-
 * https://yapi.lanhanba.com/project/176/interface/api/41187
 */
export function targetTenantCheck() {
    return _get('/v2/tenant/check', {}, { isMock: false, mockId: 176, needHint: true, isTerra: true, needCancel: false });
}
/**
 * 获取省市区
 * https://yapi.lanhanba.com/project/297/interface/api/33601
 */
export function getAreaList(type) {
    if (type === void 0) { type = 1; }
    return _get('/v2/area/list', { type: type }, {
        isMock: false,
        mockId: 353,
        needHint: true,
        isTerra: true,
        needCancel: false,
    }, 
    // 为了开启gzip压缩
    -1).then(function (_a) {
        var data = _a.data;
        if (!(Array.isArray(data) && data.length))
            return [];
        var listData = JSON.parse(JSON.stringify(data).replace(/cities|districts/g, 'children'));
        var disabledArr = ['台湾', '澳门', '香港'];
        // 特殊的几个省份的禁用
        listData.forEach(function (item) {
            var name = item.name;
            var target = disabledArr.find(function (nameItem) { return name.includes(nameItem); });
            if (target) {
                item.disabled = true;
            }
        });
        return listData;
    });
}
/**
 * 搜索城市
 * https://yapi.lanhanba.com/project/353/interface/api/51225
 */
export function cityNameSearch(params) {
    return _get("/v2/area/city/search", params, {
        isMock: false,
        mockId: 497,
        needHint: true,
        isTerra: true,
    });
}
/**
 * 当前账户信息
 * https://yapi.lanhanba.com/project/176/interface/api/34075
 */
export function getCurrentUser() {
    return _get("/v2/user/currentUser", {}, {
        isMock: false,
        // mockId: 176,
        needHint: true,
        isTerra: true,
        needCancel: false,
    });
}
/**
 * 当前菜单列表
 * https://yapi.lanhanba.com/project/469/interface/api/52492
 */
export function getMenuList() {
    return _get("/v2/user/menu/list", {}, {
        isMock: false,
        mockId: 469,
        needHint: true,
        isTerra: true,
    });
}
/**
 * oss上传 预签名
 * https://yapi.lanhanba.com/project/297/interface/api/90253
 */
export function signFile(params) {
    return _post("/v2/oss/preSign", params, {
        isMock: false,
        needHint: true,
        isTerra: true,
        needCancel: false,
    });
}
/**
 * 获取当前城市
 * 文档可参考该api文档 // https://yapi.lanhanba.com/project/208/interface/api/28549
 */
export function currentCity() {
    return _get("/v2/city/current", {}, {
        isMock: false,
        needHint: true,
        isTerra: true,
    });
}
/**
 * 根据高德地图code 返回数据库中的省市区
 * https://yapi.lanhanba.com/project/469/interface/api/52898
 */
export function accordingToCodeMap(params) {
    return _get("/v2/area/search/code", __assign({}, params), {
        isMock: false,
        needHint: true,
        isTerra: true,
    });
}
/**
 * 当前租户/企业信息
 * https://yapi.lanhanba.com/project/176/interface/api/34076
 */
export function curTenantInfo() {
    return _get("/v2/tenant/info", {}, {
        isMock: false,
        needHint: true,
        isTerra: true,
        needCancel: false,
    });
}
/**
 * 租户信息-分享场景下用（不用token就能查询，避免返回隐私信息）
 * https://yapi.lanhanba.com/project/176/interface/api/85672
 */
export function curTenantShareInfo(params) {
    return _get("/v2/tenant/shareInfo", __assign({}, params), {
        isMock: false,
        needHint: true,
        isTerra: true,
        needCancel: false,
    });
}
/**
 * 创建短链 并返回分享id
 * https://yapi.lanhanba.com/project/532/interface/api/76957
 */
export function getShareId(params, config) {
    return _post("/v2/share/shortLink/createShortLink", __assign({}, params), __assign({ needHint: true, isTerra: true, needCancel: false }, config));
}
/**
 * 根据分享id获取请求体内容
 * https://yapi.lanhanba.com/project/532/interface/api/76964
 */
export function getShareContent(params, config) {
    return _get('/v2/share/shortLink/getShortLinkInfo', __assign({}, params), __assign({ needHint: true, isTerra: true, needCancel: false }, config));
}
/**
 * 当前待处理的任务（指派我的）/机会点/审批等个数
 * https://yapi.lanhanba.com/project/353/interface/api/36784
 */
export function typesCount() {
    return _post("/v2/expandShop/task/count", {}, {
        isMock: false,
        needHint: true,
        isTerra: true,
        needCancel: false
    });
}
/**
 * 当前用户信息（可获取租户id，员工id等）
 */
export function getBriefInfo() {
    return _get("/v2/user/brief/info", {}, {
        isMock: false,
        needHint: true,
        isTerra: true,
    });
}
/**
 * 租户下的分公司列表
 * https://yapi.lanhanba.com/project/532/interface/api/59128
 */
export function getCompanyList() {
    return _post("/v2/company/list", {}, {
        isMock: false,
        needHint: true,
        isTerra: true,
    });
}
/**
 * 权限列表
 * https://yapi.lanhanba.com/project/176/interface/api/39934
 */
export function permissionsList() {
    return _get('/v2/user/permissions', {}, {
        isMock: false,
        needHint: true,
        isTerra: true,
    });
}
/**
 * 飞书鉴权：https://yapi.lanhanba.com/project/413/interface/api/84608
 */
export function authenticationByLark(params) {
    return _get('/v2/tp/feishu/jsapi/signature', __assign({}, params), {
        needHint: true,
        isTerra: true,
    });
}
/**
 * 首页底部tabbar列表
 * https://yapi.lanhanba.com/project/469/interface/api/87296
 */
export function homeBottomMenus() {
    return _get("/v2/user/bottom/menus", {}, {
        isMock: false,
        needHint: true,
        isTerra: true,
        needCancel: false
    });
}
/**
 * 首页底部tabbar publish 按钮组
 * https://yapi.lanhanba.com/project/469/interface/api/87296
 */
export function publishList() {
    return _get("/v2/user/fastCreate/menus", {}, {
        isMock: false,
        needHint: true,
        isTerra: true,
        needCancel: false
    });
}
/**
 * 获取部门列表数据
 * https://yapi.lanhanba.com/project/644/interface/api/97508
 */
export function getDepartmentPermissionList(params) {
    return _get('/v2/department/permission/list', params, { isMock: false, mockId: 644, needHint: true, isTerra: true, needCancel: false });
}
/**
 * 根据经纬度获得省市区poi名称
 * https://yapi.lanhanba.com/project/469/interface/api/75172
 */
export function postAmapLocation(params) {
    return _post('/v2/amap/location', __assign({}, params), { isMock: false, needHint: true, isTerra: true, needCancel: false });
}
/**
 * 获取企业微信 agentConfig 配置
 * @param params 包含 url 参数
 */
export function getWxWorkAgentConfig(params) {
    return _get('/v2/tp/wx/getWebConfig', __assign({}, params), { isMock: false, needHint: true, isTerra: true, needCancel: false });
}
/**
 * 用户列表(根据账号权限)（含离职员工，所以不适合作为指派用）
 * https://yapi.lanhanba.com/project/297/interface/api/92706
 */
export function userPermissionList(params) {
    return _get('/v2/user/permission/list', __assign({}, params), { isMock: false, needHint: true, isTerra: true, needCancel: false });
}
/**
 * 获取当前用户按钮权限
 * https://yapi.lanhanba.com/project/297/interface/api/33940
 */
export function getUserPermissionList(params) {
    return _get('/v2/user/permissionList', __assign({}, params), { isMock: false, needHint: true, isTerra: true, needCancel: false });
}
/**
 * 分公司-分页列表
 * https://yapi.lanhanba.com/project/469/interface/api/97796
 */
export function getBranchCompanyPages(params) {
    return _post('/v2/company/pages', __assign({}, params), { isMock: false, needHint: true, isTerra: true, needCancel: false });
}
